/***********************************************************
 Icons
 --------------------------
 Defines the application's icons.
 ************************************************************/
import {
    mdiCalendarRange,
    mdiCheck,
    mdiChevronDown,
    mdiChevronLeft,
    mdiChevronRight,
    mdiChevronUp,
    mdiClockOutline,
    mdiClose,
    mdiCog,
    mdiCursorMove,
    mdiDotsHorizontal,
    mdiDotsVertical,
    mdiDownload,
    mdiEmail,
    mdiExclamation,
    mdiHelpCircleOutline,
    mdiImageOutline,
    mdiIncognito,
    mdiInformationVariant,
    mdiLoading,
    mdiMagnify,
    mdiMapMarkerOutline,
    mdiMinus,
    mdiOpenInNew,
    mdiPencil,
    mdiPlus,
    mdiRefresh,
    mdiTune,
    mdiUpload,
    mdiUploadOff
} from '@mdi/js'

export default {

    // Directions
    more: mdiDotsHorizontal,
    back: mdiChevronLeft,
    next: mdiChevronRight,
    up: mdiChevronUp,
    down: mdiChevronDown,

    // Labels
    external_link: mdiOpenInNew,
    help: mdiHelpCircleOutline,
    options: mdiDotsVertical,
    settings: mdiCog,
    email: mdiEmail,
    image: mdiImageOutline,
    date: mdiCalendarRange,
    time: mdiClockOutline,
    location: mdiMapMarkerOutline,
    privacy: mdiIncognito,

    // Actions
    refresh: mdiRefresh,
    loading: mdiLoading,
    search: mdiMagnify,
    reset: mdiClose,
    check: mdiCheck,
    submit: mdiCheck,
    save: mdiCheck,
    cancel: mdiClose,
    remove: mdiMinus,
    close: mdiClose,
    create: mdiPlus,
    edit: mdiPencil,
    manage: mdiTune,
    destroy: mdiClose,
    move: mdiCursorMove,
    warning: mdiExclamation,
    unsaved: mdiUploadOff,
    success: mdiCheck,
    info: mdiInformationVariant,
    upload: mdiUpload,
    download: mdiDownload,
};